import React from 'react';

const S = ({ n, title, children }) => (
  <section className="space-y-2">
    <h2 className="text-lg font-semibold text-slate-800">{n}. {title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto px-6 py-10 space-y-8">
        <header className="space-y-2 border-b border-slate-200 pb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">Informativa sulla Privacy</h1>
          <p className="text-sm text-slate-500">ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 ("GDPR") — Ultimo aggiornamento: agosto 2026</p>
        </header>

        <S n="1" title="Titolare del trattamento">
          <p>
            Il Titolare del trattamento è <b>Holiday World Tenerife SL</b>, con sede in Calle Irlanda 4 LCL 4F,
            38670 Adeje Casco (Santa Cruz de Tenerife), Spagna. Contatti: tel. <b>+39 02 400 307 85</b> — email{' '}
            <a href="mailto:customerservice@holidayw.eu" className="text-blue-600 underline">customerservice@holidayw.eu</a>.
          </p>
        </S>

        <S n="2" title="Dati trattati e finalità">
          <p><b>a) Gestione delle prenotazioni e dei soggiorni.</b> Dati anagrafici, documenti d'identità e recapiti degli ospiti,
            trattati per l'esecuzione del contratto di soggiorno e per gli adempimenti di legge: comunicazione alloggiati alla
            Questura (art. 109 TULPS), rilevazioni ISTAT sui flussi turistici e imposta di soggiorno.</p>
          <p><b>b) Registrazione e trascrizione delle telefonate.</b> Le chiamate da e verso i nostri uffici possono essere registrate
            e trascritte per finalità di qualità del servizio, formazione del personale, tutela in caso di contestazioni e — ove utile —
            per l'invio al chiamante di un riepilogo scritto della conversazione. Chi chiama viene informato con un annuncio vocale
            all'inizio della telefonata; proseguendo la chiamata l'interessato ne prende atto.</p>
          <p><b>c) Sondaggi di gradimento.</b> Dopo una chiamata o la chiusura di una richiesta di assistenza possiamo inviare, via
            WhatsApp o email, un breve sondaggio di valutazione (1-5 stelle). La partecipazione è facoltativa.</p>
          <p><b>d) Monitoraggio delle caselle email aziendali.</b> Per misurare i tempi di risposta del servizio clienti trattiamo
            esclusivamente i <b>metadati</b> dei messaggi (mittente, data, oggetto): il contenuto delle email non viene letto dai sistemi di analisi.</p>
          <p><b>e) Comunicazioni operative.</b> Invio di messaggi WhatsApp o email di servizio relativi al soggiorno (istruzioni di
            check-in, video informativi, promemoria), tramite la piattaforma Spoki/WhatsApp Business.</p>
          <p><b>f) Pagamenti a proprietari e partner.</b> Dati identificativi e coordinate bancarie (IBAN) trattati per l'esecuzione
            dei bonifici SEPA dovuti per contratto.</p>
        </S>

        <S n="3" title="Basi giuridiche">
          <p>I trattamenti si fondano su: <b>obblighi di legge</b> (comunicazioni a Questura, ISTAT, adempimenti fiscali);
            <b> esecuzione del contratto</b> (gestione del soggiorno, pagamenti, assistenza); <b>legittimo interesse</b> del Titolare
            (qualità del servizio, registrazione delle chiamate, metriche di risposta, tutela in giudizio); <b>consenso</b>, ove
            specificamente richiesto (es. comunicazioni facoltative).</p>
        </S>

        <S n="4" title="Utilizzo di sistemi di intelligenza artificiale">
          <p>In conformità al Regolamento (UE) 2024/1689 ("AI Act"), informiamo che utilizziamo sistemi di IA per: la <b>trascrizione
            automatica</b> delle chiamate registrate, la <b>valutazione della qualità</b> delle conversazioni a fini di formazione
            interna e la generazione di <b>riepiloghi</b>. Le valutazioni prodotte dall'IA sono sempre soggette a supervisione umana e
            non determinano decisioni automatizzate con effetti giuridici sugli interessati. Alcuni messaggi automatici (es. sondaggi,
            comunicazioni di servizio) sono generati da sistemi automatizzati e sono riconoscibili come tali.</p>
        </S>

        <S n="5" title="Tempi di conservazione">
          <p>— Registrazioni e trascrizioni delle chiamate: fino a <b>12 mesi</b>, salvo esigenze di tutela in giudizio.<br />
            — Dati delle prenotazioni e documenti fiscali: <b>10 anni</b> (obblighi civilistici e fiscali).<br />
            — Metadati email per metriche di servizio: fino a <b>24 mesi</b>.<br />
            — Esiti dei sondaggi di gradimento: fino a <b>24 mesi</b>, in forma aggregata oltre tale termine.</p>
        </S>

        <S n="6" title="Destinatari dei dati">
          <p>I dati possono essere trattati da fornitori nominati responsabili del trattamento ex art. 28 GDPR, tra cui: Voxloud
            (centralino telefonico e registrazioni), Spoki / Meta (messaggistica WhatsApp), IONOS (posta elettronica e hosting),
            OpenAI (servizi di trascrizione e analisi con IA), istituti bancari (esecuzione bonifici SEPA), oltre alle autorità
            pubbliche nei casi previsti dalle leggi dei Paesi in cui operiamo (in Italia: Questura, ISTAT, Agenzia delle Entrate,
            enti locali per l'imposta di soggiorno; in Spagna: autorità di pubblica sicurezza e organismi statistici e fiscali competenti).</p>
        </S>

        <S n="7" title="Trasferimenti extra-UE">
          <p>Alcuni fornitori (es. Meta, OpenAI) possono comportare trasferimenti di dati verso Paesi terzi: in tali casi il
            trasferimento avviene sulla base di decisioni di adeguatezza o delle Clausole Contrattuali Standard approvate dalla
            Commissione Europea.</p>
        </S>

        <S n="8" title="Ambito internazionale e legge applicabile">
          <p>Il Titolare gestisce immobili e servizi di ospitalità in <b>diversi Paesi</b>. La presente informativa è redatta in
            conformità al GDPR, che si applica a tutti i trattamenti svolti nell'Unione Europea e nei confronti di interessati che
            si trovano nell'UE, indipendentemente dal Paese in cui si trova l'immobile. Ove le normative locali del Paese in cui è
            situato l'immobile prevedano adempimenti ulteriori (ad esempio registrazione degli ospiti presso le autorità di pubblica
            sicurezza, rilevazioni statistiche o imposte di soggiorno locali), i dati sono trattati anche per ottemperare a tali
            obblighi, nei limiti di quanto strettamente necessario.</p>
        </S>

        <S n="9" title="Diritti dell'interessato">
          <p>È possibile esercitare in ogni momento i diritti di cui agli artt. 15-22 GDPR (accesso, rettifica, cancellazione,
            limitazione, opposizione, portabilità) scrivendo a <a href="mailto:customerservice@holidayw.eu" className="text-blue-600 underline">customerservice@holidayw.eu</a>.
            È inoltre possibile proporre reclamo all'autorità di controllo: l'<b>Agencia Española de Protección de Datos</b>{' '}
            (<a href="https://www.aepd.es" className="text-blue-600 underline" target="_blank" rel="noreferrer">www.aepd.es</a>), autorità
            capofila del Titolare, oppure all'autorità del proprio Paese di residenza (per l'Italia: Garante per la Protezione dei
            Dati Personali, <a href="https://www.garanteprivacy.it" className="text-blue-600 underline" target="_blank" rel="noreferrer">www.garanteprivacy.it</a>).</p>
        </S>

        <section className="border-t border-slate-200 pt-6 space-y-2">
          <h2 className="text-lg font-semibold text-slate-800">English summary</h2>
          <p className="text-sm text-slate-600 leading-relaxed">
            Calls to and from our offices may be recorded and transcribed for service quality purposes and to send the caller a
            written summary of the conversation; callers are informed by a voice announcement at the start of the call. We may send
            optional satisfaction surveys via WhatsApp or email. AI systems are used for transcription and quality assessment under
            human supervision. Guest data is processed to manage bookings and to comply with the laws of the country where the
            property is located (e.g. police reporting, tourist statistics, tourist tax). Data controller: Holiday World Tenerife SL,
            Calle Irlanda 4 LCL 4F, 38670 Adeje (Spain). To exercise your GDPR rights, write to{' '}
            <a href="mailto:customerservice@holidayw.eu" className="text-blue-600 underline">customerservice@holidayw.eu</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
